import { groupBy, map, orderBy } from "lodash";
import React  from "react";
import { TApiParameter } from "../../../api/endpoints/Parameter";
import { QuantiledParam } from "../../../entities/QuantiledParam";

interface IProps {
  value: Array<QuantiledParam>;
  params: {
    [shortname: string]: TApiParameter
  };
}

const ParamQuantile = (props: IProps) => {
  const { value, params } = props;

  const grouped = groupBy(value, 'param');

  return (
    <div className="param-quantile-formatter">
      {
        map(grouped, (group, shortname) => {
          const shortnameLowerCase = shortname.toLowerCase();
          const matchedParam = params[shortnameLowerCase];

          return (
            <div className="group" key={shortname}>
              <div className="header">
                {
                  matchedParam ?
                    `${matchedParam.name} (${shortnameLowerCase}):`
                    : `${shortnameLowerCase}:`
                }
              </div>
              <div className="values">
                {
                  orderBy(group, param => param.quantile.split(':')[0])
                    .map(param => param.quantile).join(', ')
                }
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default ParamQuantile;
